module.exports = __webpack_public_path__ + "static/img/pottery_wx.836c4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/pottery_wx.png
// module id = t4DL
// module chunks = 26